import React from "react";
import Expansion from "components/Expansion";
import ExpansionComponent from "components/ExpansionComponent";
import Button from "storybookComponents/Button"
import SocialMediaOptions from "./socialMediaOptions"
import Picker from "storybookComponents/Picker";
import ShareButton from "./shareButton";
import { Twitter, Facebook } from "icons";
import SharePopup from "./SharePopup";
import PopupBody from "./SharePopup/PopupBody";
import { socialMediaShareDate } from "../../util"

const SocialMediaShare = ({ classes, expanded, handleExpandedPanel, showNotification, id, timezoneString, ...props }) => {
  const [innerExpanded, setExpanded] = React.useState("first");
  const [open, setOpen] = React.useState(false);
  const [twitterValues, setTwitterValues] = React.useState({
    text: `Join us for ${props.title}! ${socialMediaShareDate(props.startAt, timezoneString)} while supplies last. Look for us by the front gate.\nDon't miss out!`,
    image: props.image ? props.image.thumbnailUrl : null
  });
  const [facebookValues, setFacebookValues] = React.useState({
    text: `Join us for ${props.title}! ${socialMediaShareDate(props.startAt, timezoneString)} while supplies last. Look for us by the front gate.\nDon't miss out!`,
    image: props.image ? props.image.thumbnailUrl : null
  });

  console.log("props", props)

  const handleRightSection = (open) => {
    return null
  }

  const handleInnerExpandedPanel = (panel) => {
    if (panel === innerExpanded)
      setExpanded("");
    else
      setExpanded(panel);
  };

  const handleDateChange = () => {

  }

  const onClick = (type) => {
    setOpen(type)
  }


  const handleClose = () => {
    setOpen(null)
  }

  const handleChange = (type, key, value) => {
    if (type === "twitter") {
      setTwitterValues({
        ...twitterValues,
        [key]: value
      })
    } else {
      setFacebookValues({
        ...facebookValues,
        [key]: value
      })
    }
  }

  const onShareButtonClick = (type) => {
    const linkMyHyly = "https://" + process.env.REACT_APP_MyhylyHost + "/mktg/hyevents/" + id + "/landing_page";
    console.log("linkMyHyly", linkMyHyly)
    //  const link = https://my.hy.ly/mktg/hyevents/%3Cevent_id%3E/landing_page
    if (type === "twitter") {
      window.open("https://twitter.com/share?text=" + encodeURIComponent(twitterValues.text) + "&url=" + linkMyHyly);
    } else {
      window.open("https://www.facebook.com/sharer.php?quote=" + encodeURIComponent(facebookValues.text) + "&u=" + linkMyHyly)
    }
  }

  return (
    <Expansion
      expanded={expanded === "Fourth"}
      name="Fourth"
      handleExpandedPanel={handleExpandedPanel}
      header="Share Invite on Social Media"
      rightSection={handleRightSection}
      subtitle="Click on below social media share buttons to continue to post the event invite"
    >
      <div className={classes.innerExpansionContainer}>
        <div className={classes.removeButtons}>
          <ShareButton text="Facebook" onClick={onClick.bind(this, "facebook")} icon={<Facebook />} />
          <ShareButton text="Twitter" onClick={onClick.bind(this, "twitter")} icon={<Twitter />} />
        </div>
        <SharePopup
          handleClose={handleClose}
          open={open}
          icon={open === "facebook" ? <Facebook stroke="white" /> : <Twitter stroke="white" />}
          text={open === "facebook" ? "Share on Facebook" : "Share on Twitter"}
          onShareButtonClick={onShareButtonClick}
        >
          <PopupBody
            showNotification={showNotification}
            values={
              open === "facebook" ? facebookValues : twitterValues
            }
            type={open}
            handleChange={handleChange} />
        </SharePopup>


        {/* <ExpansionComponent
          expanded={innerExpanded === "first"}
          name="first"
          header="1. Select social media platforms"
          handleExpandedPanel={handleInnerExpandedPanel}
        >
          <SocialMediaOptions classes={classes} />
        </ExpansionComponent>
        <div className={classes.hrLine}></div>
        <ExpansionComponent
          expanded={innerExpanded === "second"}
          name="second"
          handleExpandedPanel={handleInnerExpandedPanel}
          header="2. Select schedule date & time"
          subtitle="Select a date & time to share the event invite on above selected platforms"
        >
          <div className={classes.textField} id="hyly-datePicker">
            <Picker format={true} type="datetime" icon={true} handleChange={handleDateChange} placeholderText="Date & Time" defaultValue={""} />
          </div>
        </ExpansionComponent>
        <Button className={classes.button} variant="primary" size="sm">Schedule Invites</Button> */}
      </div>
    </Expansion>
  )
}


export default SocialMediaShare